import { useSkillsFrameworks } from "PFCore/hooks/queries/admin/skills_frameworks/use_skills_frameworks";

export const useSkillsFrameworksCounters = () => {
  const { data: primaryFrameworks } = useSkillsFrameworks({
    page: 1,
    perPage: 0,
    filters: {
      fields: {
        rank: "primary"
      }
    }
  });

  const { data: secondaryFrameworks } = useSkillsFrameworks({
    page: 1,
    perPage: 0,
    filters: {
      fields: {
        rank: "secondary"
      }
    }
  });

  return {
    primary: primaryFrameworks?.meta.total,
    secondary: secondaryFrameworks?.meta.total
  };
};
